import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AgentDashboard } from "@/components/AgentDashboard";
import { AdminDashboard } from "@/components/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (user.role === "payment_team") return <Navigate to="/payment-desk" replace />;
  if (user.role === "admin") return <AdminDashboard />;
  return <AgentDashboard />;
}
